@if (!loading()) {
  <div class="auth-main-wrapper">
    <div class="auth-image">
      <div
        class="banner"
        [ngStyle]="{
          'background-image': 'url(' + dataStore.theming?.loginImage + ')',
        }"
      ></div>
    </div>
    <div class="auth-wrapper">
      @switch (currentView()) {
        @case ('start') {
          <div class="auth-start">
            <div
              class="logo"
              [ngStyle]="{
                'background-image': 'url(' + dataStore.theming?.logo + ')',
              }"
            ></div>
            <h1 class="auth-title">Welkom op de passagiersomgeving van {{ dataStore.theming?.name }}</h1>
            <p class="sub-title">Hoe kunnen we u helpen?</p>
            <div class="button-wrapper">
              <button mat-stroked-button routerLink="/auth/register">Registreren</button>
              <button mat-flat-button routerLink="/auth/login">Inloggen</button>
            </div>
          </div>
        }
        @case ('login') {
          <div class="auth-login-wrapper">
            <div class="auth-login">
              <div
                class="logo"
                [ngStyle]="{
                  'background-image': 'url(' + dataStore.theming?.logo + ')',
                }"
              ></div>
              <h1 class="auth-title">Log in op de passagiersomgeving van {{ dataStore.theming?.name }}</h1>
              <app-login></app-login>
            </div>
          </div>
        }
        @case ('register') {
          <div class="auth-register-wrapper">
            <div class="auth-register">
              <div
                class="logo"
                [ngStyle]="{
                  'background-image': 'url(' + dataStore.theming?.logo + ')',
                }"
              ></div>
              <h1 class="auth-title">Registreer nu bij de passagiersomgeving van {{ dataStore.theming?.name }}</h1>
              <app-register></app-register>
            </div>
          </div>
        }
        @case ('reset-password') {
          <div class="auth-reset-password-wrapper">
            <div class="auth-reset-password">
              <div
                class="logo"
                [ngStyle]="{
                  'background-image': 'url(' + dataStore.theming?.logo + ')',
                }"
              ></div>
              <h1 class="auth-title">Wachtwoord vergeten?</h1>
              <p class="sub-title">
                Vul hier je e-mailadres in en wij sturen je instructie om je wachtwoord opnieuw in te stellen.
              </p>
              <app-reset-password></app-reset-password>
            </div>
          </div>
        }
      }
    </div>
  </div>
}
@if (loading()) {
  <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
